import { en_countriesTranslation } from 'assets/locale/en/core/en_countriesTranslation';

const englishTranslation = {
  ...en_countriesTranslation,
  // HEADER //////////////////
  // Nav
  'header_nav_home': 'Home',
  'header_nav_dashboard': 'Dashboard',
  'header_nav_catalog': 'Catalog',
  'header_nav_catalog-download': 'Download catalog',
  'header_nav_multimedia': 'Multimedia',
  'header_nav_my-brands': 'My Brands',
  'header_sub-nav_view-catalog': 'View Catalog',
  'header_sub-nav_add-product': 'Add Product',
  'header_sub-nav_multimedia-catalog': 'Multimedia Catalog',
  'header_sub-nav_multimedia-catalog-videos': 'Videos',
  'header_sub-nav_multimedia-catalog-images': 'Images',
  'header_sub-nav_multimedia-catalog-banners': 'Banners',
  'header_sub-nav_my-brands-list': 'Brands List',
  'header_sub-nav_add-brand': 'Add Brand',
  'header_nav_sales': 'Sales',
  'header_nav_sales-history': 'Upload History',
  // Notifications
  'header_notifications_empty-notifications': 'There are no notifications',
  ////////////////////////////

  // SIGNUP PAGE /////////////
  'signup-page_title': 'Sign up for:',
  'signup-page_sub-title': 'Sign up to expand your business',
  'signup-page_button-brand': 'Sign up as a Brand',
  'signup-page_button-multibrand': 'Sign up as a Wholesale',
  'signup-page_button-brand-wh': 'Sign Up as a Brand or Multi-brand',
  'signup-page_return-to-login': 'Return to login',
  ////////////////////////////

  // HOME PAGE ///////////////
  'home-page_brands_my-brands_title': 'My Brands',
  'home-page_brands_item_button-see-catalog': 'View Catalog',
  'home-page_brands_my-brands_my-brands-link': 'Go to My Brands',
  'home-page_brands_all-brands_title': 'Brands on HUB',
  'home-page_brands_all-brands_see-more': 'See all',
  'home-page_brands_all-brands_see-less': 'See less',
  'home-page_brands_item_button-connect': 'Connect',
  'home-page_brands_item_button-see-profile': 'View Profile',
  'home-page_brands_item_button-pending': 'Pending',
  'home-page_brands_item_button-disconnected': 'Disconnected',
  'home-page_brands_item_empty-brands': 'No associations yet',
  'home-page_brands_see_more': 'See more',
  'home-page_brands_see_brand': 'View Profile',
  'home-page_brands_no_more_results': 'No results found...',
  'home-page_brands_connect-modal_title': 'The request has been sent to the brand!',
  'home-page_brands_connect-modal_text1': 'Hub4Retail will get in touch with the brand to associate it.',
  'home-page_brands_connect-modal_text2': 'We will be sending you an email updating you.',
  'home-page_brands-not-associated_title': 'Brands you sell not associated',
  'home-page_brands-not-associated_search-input-placeholder': 'Search in unassociated brands',
  'home-page_brands-not-associated_selected-brand': 'selected brand',
  'home-page_brands-not-associated_selected-brands': 'selected brands',
  'home-page_brands-not-associated_select-all': 'Select all',
  'home-page_brands-not-associated_clear-select': 'Clear selection',
  'home-page_brands-not-associated_associate-btn': 'Associate brands',
  'home-page_my-brands_search-input-placeholder': 'Search in my brands',
  ////////////////////////////

  // ACCOUNT PAGE /////////////
  'profile-page_nav_profile': 'Profile',
  'profile-page_nav_company': 'Company Information',
  'profile-page_nav_main-contacts': 'Main Contacts',
  'profile-page_nav_my-brands': 'My Brands',
  'profile-page_nav_points-of-sale': 'Store',
  /////////////////////////////

  // DASHBOARDS //////////////
  'dashboard_empty-dashboard': 'Contact Hub4Retail to enable this service.',
  'dashboard_dashboard_error': 'Error loading the dashboard. If the problem persists, contact:',
  'dashboard_maintenance_message': 'We are working for you!!',
  /////////////////////////////

  // HELMET ///////////////////
  'signup': 'Sign up',
  'home': 'Home',
  'dashboard': 'Dashboard',
  'multimedia': 'Multimedia',
  'multimedia-videos': 'Multimedia videos',
  'multimedia-images': 'Multimedia images',
  'multimedia-banners': 'Multimedia Banners',
  'clients': 'Clients',
  'profile': 'Profile',
  'company': 'Company Information',
  'main-contacts': 'Main Contacts',
  'commercial-info': 'Commercial Information',
  'points-of-sale': 'Stores',
  'catalog': 'Catalog',
  'catalog_download': 'Download catalog',
  'notifications': 'Notifications',
  'helmet_settings': 'Settings',
  'helmet_meta': 'Meta',
  'helmet_meta_edit_connection': 'Meta - Edit connection',
  'helmet_meta_edit_map': 'Meta - Edit map',
  'helmet_users': 'Users',
  'helmet_sales-history': 'Sales History',
  'helmet_upload-sales': 'Upload Sales',
  /////////////////////////////

  // USERS ///////////////////////
  // Departments
  'users_department_commercial': 'Commercial',
  'users_department_administration': 'Administration',
  'users_department_agent': 'Agent',
  'users_department_owner': 'Owner',
  'users_department_store-manager': 'Store Manager',
  'users_department_logistics': 'Logistics',
  'users_department_marketing': 'Marketing',
  'users_department_others': 'Others',
  ////////////////////////////////

  // SUPERADMIN //////////////////
  'super-admin_search-input_placeholder': 'Search...',
  ////////////////////////////////

  // ACCOUNT //////////////////
  'account_profile_title': 'My Profile',
  'account-info-panel_title': 'General Information',
  'account-company-info-panel_title': 'Company Data',
  // Profile
  'account-info-panel_profile_name': 'Name',
  'account-info-panel_profile_lastname': 'Last Name',
  'account-info-panel_profile_email': 'Email',
  'account-info-panel_profile_phone-number': 'Phone Number',
  'account-info-panel_profile_sector': 'Departament',
  'account-info-panel_profile_security-data': 'Security Data',
  'account-info-panel_profile_change-password': 'Change Password',
  'account-info-panel_profile_pwd_password-label': 'New Password',
  'account-info-panel_profile_pwd_repeat-password-label': 'Repeat the New Password',
  'account-info-panel_profile_pwd_change-button': 'Change Password',
  'account-info-panel_profile_pwd_validation': 'The password must be at least 8 characters and a maximum of 16, 1 number, 1 uppercase letter, and one lowercase letter.',
  'account-info-panel_profile_pwd_validation-match': 'The passwords do not match',
  'account-info-panel_profile_pwd_change-success': 'Password changed successfully.',
  'account-info-panel_profile_pwd_empty-inputs': 'Fill in the empty fields.',
  // Profile form
  'account-profile_form-input_name': 'Enter your name',
  'account-profile_form-input_name-validation': 'Please enter your name',
  'account-profile_form-input_lastname': 'Enter your last name',
  'account-profile_form-input_lastname-validation': 'Please enter your last name',
  'account-profile_form-input_email': 'Enter your email',
  'account-profile_form-input_email-validation-required': 'Please enter your email',
  'account-profile_form-input_email-validation': 'The email is not valid',
  'account-profile_form-input_sector': 'Enter the departament',
  'account-profile_form-input_sector-validation': 'Please enter the departament',
  'account-profile_form-input_phone-number': '',
  'account-profile_form-input_phone-number-validation': 'Please enter the phone number',
  // Company
  'account-info-panel_company_title': 'Company Data',
  'account-info-panel_company_cif': 'Tax ID',
  'account-info-panel_company_trade-name': 'Brand Name',
  'account-info-panel_company_business-name': 'Company Name',
  'account-info-panel_company_address': 'Address',
  'account-info-panel_company_postal-code': 'Postal Code',
  'account-info-panel_company_population': 'City',
  'account-info-panel_company_country': 'Country',
  'account-info-panel_company_province': 'Province',
  'account-info-panel_company_contact_name': 'Primary Contact',
  'account-info-panel_company_email': 'Email',
  'account-info-panel_company_phone-number': 'Phone Number',
  'account-info-panel_matas-connected_title': 'Metas Connected',
  'account-info-panel_active-connections_title': 'Active Connections',
  // Company form
  'account-company_form-input_trade-name': 'Enter the Brand Name',
  'account-company_form-input_trade-name-validation': 'Please enter the brand name',
  'account-company_form-input_business-name': 'Enter the Company Name',
  'account-company_form-input_business-name-validation': 'Please enter the company name',
  'account-company_form-input_country': 'Enter the country',
  'account-company_form-input_country-validation': 'Please enter the country',
  'account-company_form-input_population': 'Enter the City',
  'account-company_form-input_population-validation': 'Please enter the city',
  'account-company_form-input_address': 'Enter the address',
  'account-company_form-input_address-validation': 'Please enter your address',
  'account-company_form-input_postal-code': 'Enter the postal code',
  'account-company_form-input_postal-code-validation': 'Please enter the postal code',
  'account-company_form-input_cif': 'Enter the VAT (Tax Identification)',
  'account-company_form-input_cif-validation': 'Please enter the VAT (Tax Identification)',
  'account-company_form-input_phone-number': 'Phone Number',
  'account-company_form-input_phone-number-validation': 'Please enter the phone number',
  'account-company_form-input_contact_name': "Enter the company's primary contact",
  'account-company_form-input_contact_name-validation-required': "Please enter the company's primary contact",
  'account-company_form-input_email': 'Enter the company email',
  'account-company_form-input_email-validation-required': 'Please enter your email',
  'account-company_form-input_email-validation': 'The email is not valid',
  'account-company_form-input_instagram': 'Enter Instagram URL',
  'account-company_form-input_youtube': 'Enter Youtube URL',
  'account-company_form-input_linkedin': 'Enter Linkedin URL',
  'account-company_form-input_facebook': 'Enter Facebook URL',
  'account-company_social-media-title': 'Social Media',
  'account-company_form-input_social-media-label': 'Social Media Name',
  'account-company_form-input_social-media-label-placeholder': 'Social Media Name',
  'account-company_form-input_social-media-label_validation': 'Please, enter the social media name',
  'account-company_form-input_social-media-value': 'Social Media URL',
  'account-company_form-input_social-media-value-placeholder': 'Social Media URL',
  'account-company_form-input_social-media-value_validation': 'Please, enter the social media URL',
  'account-company_form-input_social-media-add-button': 'Add Social Media',
  'account-company_form-input_social-media-accept-button_title': 'Update Social Media',
  'account-company_form-input_social-media-reject-button_title': 'Discard changes',
  'account-company_form-input_social-media-delete-button_title': 'Delete Social Media',
  'account-company_form-input_social-media-delete-button_popconfirm_title': 'Delete Social Media',
  'account-company_form-input_social-media-delete-button_popconfirm_description': 'Are you sure you want to delete this Social Media?',
  'account-company_form-input_social-media-delete-button_popconfirm_ok': 'Delete',
  'account-company_form-input_social-media-delete-button_popconfirm_cancel': 'Cancel',
  // Company drawer
  'account-company_drawer_title': 'Company Data',
  // Main Contacts
  'main-contacts_title': 'Main Contacts',
  'main-contacts_add-contact': '+ Add',
  'main-contacts_table_name': 'Name',
  'main-contacts_table_lastname': 'Last Name',
  'main-contacts_table_email': 'Email',
  'main-contacts_table_phone-number': 'Phone Number',
  'main-contacts_table_department': 'Department',
  'main-contacts_table_pop-confirm_title': 'Delete contact',
  'main-contacts_table_pop-confirm_description': 'Are you sure you want to delete this contact?',
  'main-contacts_table_pop-confirm_btn-accept': 'Delete',
  'main-contacts_table_pop-confirm_btn-cancel': 'Cancel',
  // Main Contacts drawer
  'main-contacts_drawer_create-title': 'Create contact',
  'main-contacts_drawer_update-title': 'Update contact',
  // Main Contacts Form
  'main-contacts_form-label_name': 'Name',
  'main-contacts_form-label_lastname': 'Last Name',
  'main-contacts_form-label_email': 'Email',
  'main-contacts_form-label_phone-number': 'Phone Number',
  'main-contacts_form-label_department': 'Department',
  'main-contacts_form-input_name': 'Enter the name',
  'main-contacts_form-input_lastname': 'Enter the last name',
  'main-contacts_form-input_email': 'Enter the email',
  'main-contacts_form-input_department': 'Enter the department',
  'main-contacts_form_sector_label': 'Department',
  'main-contacts_form-input_sector': 'Enter the department',
  'main-contacts_form-input_sector_validation': 'Enter the department',
  'main-contacts_form-input_phone-number': 'Enter the phone number',
  'main-contacts_form-input-validation_name': 'Please enter the name',
  'main-contacts_form-input-validation_lastname': 'Please enter the last name',
  'main-contacts_form-input-validation_email': 'The email is not valid',
  'main-contacts_form-input-validation-required_email': 'Please enter the email',
  'main-contacts_form-input-validation_department': 'Please enter the department',
  // My brands
  'my-brands_title': 'My Brands',
  'my-brands_add-to-my-brands': '+ Add',
  'my-brands_table_brand-name': 'Brand Name',
  'my-brands_table_main-contact': 'Main Contact',
  'my-brands_table_phone-number': 'Phone Number',
  'my-brands_table_email': 'Email',
  'my-brands_table_address': 'Address',
  'my-brands_table_city': 'City',
  'my-brands_table_pop-confirm_title': 'Unlink from my brands',
  'my-brands_table_pop-confirm_description1': 'Are you sure you want to unlink',
  'my-brands_table_pop-confirm_description2': 'from my brands?',
  'my-brands_table_pop-confirm_btn-accept': 'Unlink',
  'my-brands_table_pop-confirm_btn-cancel': 'Cancel',
  'my-brands_table_disassociate-tooltip-title': 'Unlink brand',
  'my-brands_table_resend-association': 'Resend association',
  // My brands drawer
  'my-brands_drawer_title': 'Search and Add Brands',
  'my-brands_drawer_add-title': 'Create New Brand',
  'my-brands_drawer_go-back-to-brands': 'Go Back',
  'my-brands_drawer_form_address': 'Address',
  'my-brands_drawer_form_address-street-number': 'Street and Number',
  'my-brands_drawer_form_contact': 'Contact Person',
  'my-brands_drawer_form_contact_name': 'Name',
  'my-brands_drawer_form_contact_lastname': 'Last Name',
  'my-brands_drawer_search-placeholder': 'Search',
  'my-brands_drawer_more-brands': "Want a brand you don't see here?",
  'my-brands_drawer_close-drawer': 'Close',
  'my-brands_drawer_brand_associate-btn': 'Associate',
  'my-brands_drawer_brand_see-profile-btn': 'View Profile',
  'my-brands_disassociate-modal_title': 'Unlink',
  'my-brands_disassociate-multiple-modal_title': 'Unlink Brands',
  'my-brands_disassociate-multiple-modal_content': 'Are you sure you want to unlink the selected brands and all their points of sale?',
  'my-brands_disassociate-multiple-modal_popconfirm-description': 'Are you sure you want to unlink the selected brands?',
  'my-brands_disassociate-modal_on-ok': 'Unlink',
  'my-brands_disassociate-modal_on-cancel': 'Cancel',
  'my-brands_disassociate-modal_content': 'Are you sure you want to unlink this brand and all its outlets?',
  'my-brands_resend-association-email-modal_title': 'Enter email',
  'my-brands_resend-association-email-modal_form_email-label': 'Email',
  'my-brands_resend-association-email-modal_form_email-required': 'Please enter the email',
  'my-brands_resend-association-email-modal_form_email-placeholder': 'Enter the email',
  // Shared
  'notification-form-item_label': 'Notification settings',
  'my-brands_select-tenant_popover-title': 'Select the company',
  /////////////////////////////

  // MULTIMEDIA ///////////////
  'multimedia_nav-videos': 'Videos',
  'multimedia_nav-images': 'Images',
  'multimedia_sort-btn': 'Sort by',
  'multimedia_filter-btn': 'Filters',
  'multimedia_apply-filters-btn': 'Apply filters',
  'multimedia_search-input-placeholder': 'Search by brand, season, country, date',
  'multimedia_search-results': 'Results',
  'multimedia_sort-last-favorites': 'Favorites',
  'multimedia_download': 'Download',
  'multimedia_download_started': 'The download has started',
  'multimedia_open': 'Open',
  'multimedia_link-copied': 'Link copied to clipboard',
  'multimedia_link-copy-button': 'Copy link',
  // Sort by
  'multimedia_sort-last-aggregates': 'Last added',
  'multimedia_sort-best-seller': 'Best seller',
  'multimedia_sort-less-sold': 'Least sold',
  'multimedia_sort-best-pvp_great-minor': 'Price: high to low',
  'multimedia_sort-best-pvp_minor-great': 'Price: low to high',
  'multimedia_sort-best-pvi_great-minor': 'PVI: high to low',
  'multimedia_sort-best-pvi_minor-great': 'PVI: low to high',
  'multimedia_sort-by-color': 'By color A-Z',
  'multimedia_sort-by-reference': 'By reference A-Z',
  // Images
  'multimedia_images_popover-edit': 'Edit',
  'multimedia_images_popover-remove': 'Remove',
  'multimedia_images_popover-yes': 'Yes',
  'multimedia_images_popover-no': 'No',
  // Filter
  'multimedia_filter-remove-filters': 'Clear Filters',
  'multimedia_filter-season': 'Season',
  'multimedia_filter-division': 'Division',
  'multimedia_filter-genders': 'Gender',
  'multimedia_filter-visualization': 'Visualization',
  'multimedia_filter-image-rights': 'Image Rights',
  'multimedia_filter-country': 'Country',
  'multimedia_filter-tags': 'Tags',
  'multimedia_filter-favorites': 'My Favorites',
  'multimedia_filter-start': 'Broadcastable From',
  'multimedia_filter-end': 'Broadcastable Until',
  // Dragger
  'multimedia_upload-images-manually_dragger_msg-error': 'Accepted Files',
  'multimedia_upload-images-manually_dragger_text-1': 'Click or drag and drop an image',
  // Upload image manually
  'multimedia_upload-images-manually_form-item_selection': 'Select',
  'multimedia_upload-images-manually_form-item_title': 'Title',
  'multimedia_upload-images-manually_form-item_title-required': 'Please enter the image title',
  'multimedia_upload-images-manually_form-item_name': 'Technical Name',
  'multimedia_upload-images-manually_form-item_name-required': 'Please enter the image name',
  'multimedia_upload-images-manually_form-item_description': 'Description',
  'multimedia_upload-images-manually_form-item_description-required': 'Please enter the description',
  'multimedia_upload-images-manually_form-item_divisions': 'Divisions',
  'multimedia_upload-images-manually_form-item_season': 'Season',
  'multimedia_upload-images-manually_form-item_language': 'Language',
  'multimedia_upload-images-manually_form-item_genders': 'Genders',
  'multimedia_upload-images-manually_form-item_products': 'Products',
  'multimedia_upload-images-manually_form-item_catalog_id': 'Catalog ID',
  'multimedia_upload-images-manually_form-item_catalog_id_text-1': 'Field associated with chronos to define its advertising circuit',
  'multimedia_upload-images-manually_form-item_catalog_id_text-2': 'Contact Hub4Retail to activate Chronos',
  'multimedia_upload-images-manually_form-item_usage': 'Content Use',
  'multimedia_upload-images-manually_form-item_visualization': 'Visualization',
  'multimedia_upload-images-manually_form-item_tags': 'Tags',
  'multimedia_upload-images-manually_form-item_tags_text-1': 'Create your own tags',
  'multimedia_upload-images-manually_form-item_start': 'Broadcastable From',
  'multimedia_upload-images-manually_form-item_end': 'Broadcastable Until',
  'multimedia_upload-images-manually_form-item_copyright': 'Is this video subject to image rights?',
  'multimedia_upload-images-manually_form-item_enable_download': 'Do you allow downloading?',
  'multimedia_upload-images-manually_form-item_countries': 'Countries',
  'multimedia_upload-images-manually_form-item_add': 'Add',
  'multimedia_upload-images-manually_form-item_next': 'Next',
  'multimedia_upload-images-manually_form-item_yes': 'Yes',
  'multimedia_upload-images-manually_form-item_no': 'No',
  // Modal manually
  'multimedia_upload-images-manually_modal_title': 'Update Image',
  'multimedia_upload-images-manually_modal_step-1': 'Select an image',
  'multimedia_upload-images-manually_modal_step-2': 'Complete the data',
  'multimedia_upload-images-manually_modal_step-2-msg': 'Image title',
  'multimedia_upload-images-manually_modal_step-3-msg': 'Image uploaded successfully',
  // Upload images CSV
  'multimedia_upload-images_button': 'Upload Images',
  'multimedia_upload-images_step-1': 'Select Images',
  'multimedia_upload-images_step-1_dragger_text-1': 'Click or drag and drop image files',
  'multimedia_upload-images_step-1_dragger_text-2': 'Keep the following in mind...',
  'multimedia_upload-images_step-1_dragger_text-3': 'Save the images with the name',
  'multimedia_upload-images_step-1_dragger_text-4': 'reference_color_image number',
  'multimedia_upload-images_step-2': 'Upload CSV',
  'multimedia_upload-images_step-2_dragger_text-1': 'Click or drag and drop the CSV file',
  'multimedia_upload-images_step-3': 'Upload Completed!',
  'multimedia_upload-images_step-3-text': 'image files uploaded',
  'multimedia_upload-images_modal_title': 'Upload Images',
  'multimedia_upload-images_modal_btn-back': 'Back',
  'multimedia_upload-images_modal_btn-next': 'Next',
  'multimedia_upload-images_modal_btn-close': 'Close',
  ////////////////////////////

  // BRAND USERS /////////////////
  'brand-user_title': 'Users',
  'brand-user_description': 'Control how members of your team interact with Hub4Retail.',
  'brand-user_create-user': 'Add user',
  'brand-user_modal_title-create': 'Add user',
  'brand-user_modal_title-edit': 'Edit user',
  'brand-user_modal_input_name': 'Name',
  'brand-user_modal_input_lastname': 'Last name',
  'brand-user_modal_input_email': 'Email',
  'brand-user_modal_input_points-of-sale': 'Points of sale',
  'brand-user_modal_input_password': 'Password',
  'brand-user_modal_input_btn-save': 'Save',
  'brand-user_modal_input_btn-cancel': 'Cancel',
  'brand-user_table_name': 'Name',
  'brand-user_table_email': 'Email',
  'brand-user_table_role': 'Role',
  'brand-user_table_last-session': 'Last session',
  'brand-user_table_last-session-never': 'Never',
  'brand-user_delete-popconfirm_title': 'Delete the user',
  'brand-user_delete-popconfirm_description': 'Are you sure you want to delete this user?',
  'brand-user_delete-popconfirm_confirm': 'Yes',
  'brand-user_delete-popconfirm_cancel': 'No',
  'brand-user_delete-popconfirm_icon-tooltip': 'Delete connection',
  ////////////////////////////////

  // CATALOG //////////////////
  'catalog_add-product': 'Add product',
  'catalog_ProductList_results': 'Results',
  'catalog_no-more-results': 'No results found...',
  'catalog_no-more-results_with-pos-sales': 'You have no sales at your points of sale',
  'catalog_tags_delete-all': 'Delete all',
  'catalog_loading-filters': 'Loading filters',
  'catalog_selected-brands-title': 'Selected brands',
  'catalog_brand-tag': 'Brand',
  'catalog_brands-tag': 'Brands',
  // Sort by
  'catalog_sort-all-brands': 'All Brands',
  'catalog_brand-feed-btn': 'Brand Profile',
  // Catalog download
  'catalog_search-input-placeholder': 'Search by reference, color or description',
  'catalog_download_alert_brand-required': 'Please select a brand',
  'catalog_download_alert_get-filters-error': 'Error getting filters',
  'catalog_download_alert_dowloading-compressed-files': 'Downloading compressed files...',
  'catalog_download_progress-images': 'Images',
  'catalog_download_success-msg': 'Images downloaded successfully',
  'catalog_download_success-msg-imgs-and-csv': 'CSV and images downloaded successfully',
  'catalog_download_csv-msg-without-images': 'CSV downloaded successfully',
  'catalog_download_csv-msg-pending-images': 'CSV downloaded successfully, but there are pending images',
  'catalog_download_csv-msg-pending-images-navigate': 'CSV downloaded successfully, but there are pending images. You can continue browsing while downloading',
  'catalog_download_apply-changes-btn': 'Apply changes',
  'catalog_download_cancel-filter-btn': 'Cancel',
  'catalog_download_cancel-values-selection-btn': 'Clear selection',
  'catalog_download_cancel-values-download-btn': 'Cancel download',
  'catalog_download_clear-filters-btn': 'Clear filters',
  'catalog_download_result': 'result',
  'catalog_download_results': 'results',
  'catalog_download_columns_all-images': 'All products',
  'catalog_download_columns_with-images': 'With images',
  'catalog_download_columns_without-images': 'Without images',
  'catalog_download_columns_favorites': 'Favorites',
  'catalog_download_columns_not-downloaded': 'Not downloaded',
  'catalog_download_columns_column-search_search': 'Search',
  'catalog_download_columns_column-search_reset': 'Reset',
  'catalog_download_columns_column-search_close': 'Close',
  'catalog_download_list_select-all': 'Select all',
  'catalog_download_list_clear-all': 'Clear selection',
  'catalog_download_list_download-btn': 'Download',
  'catalog_download_list_download-images-btn': 'Download images',
  'catalog_download_list_item': 'item',
  'catalog_download_list_items': 'items',
  'catalog_download_list_select-order_popover-title': 'Select and order',
  //////////////////////////////

  // TABLES ///////////////////////////////////////
  'table_columns_brand': 'Brand',
  'table_columns_reference': 'Reference',
  'table_columns_ean': 'Brand EAN',
  'table_columns_size': 'Size',
  'table_columns_name': 'Name',
  'table_columns_color': 'Color description',
  'table_columns_color_code': 'Color code',
  'table_columns_pvi': 'PVI',
  'table_columns_pvpr': 'PVPR',
  'table_columns_division': 'Division',
  'table_columns_gender': 'Gender',
  'table_columns_season': 'Season',
  'table_columns_segmentation': 'Segmentation',
  'table_columns_family': 'Family',
  'table_columns_material': 'Composition',
  'table_columns_images': 'Images',
  'table_columns_product_description': 'Product description',
  'table_columns_client_ean': 'Multibrand EAN',
  'table_columns_count': 'Repetitions',
  'table_columns_size_uk': 'Size UK',
  'table_columns_size_us': 'Size US',
  'table_columns_brand_name': 'Brand name',
  /////////////////////////////////////////////////

  // PRODUCT ///////////////////
  'product_infoBox_codeEAN': 'Codes',
  'product_collection_title': 'The Entire Collection',
  'product_infoProduct_other_colors': 'Other Colors',
  'product_infoProduct_currency': '€',
  'product_infoProduct_sizes': 'Sizes and prices',
  'product_infoProduct_EAN_size': 'Size',
  'product_infoProduct_EAN_code': 'EAN Code',
  'product_collapse_title_key1': 'Sizes',
  'product_collapse_title_key2': 'GENERAL INFORMATION',
  'product_collapse_title_key3': 'COMPOSITION',
  'product_card-color': 'Color',
  'product_mobile_product-details_size': 'Size',
  'product_mobile_product-details_info': 'General Information',
  'product_mobile_product-details_ean-codes': 'EAN Codes',
  'product_mobile_product-details_ean-code': 'EAN Code',
  'product_mobile_product-details_composition': 'Composition',
  'product_related-videos_title': 'Multimedia Catalog',
  'product_related-videos_subtitle': 'Related Videos',
  'product_related-products_title': 'You might also be interested in...',
  'product_card_sold-units': 'Sold units:',
  'product_card_ranking': 'Ranking:',
  //////////////////////////////

  // POINTS OF SALE ///////////
  'points-of-sale_title': 'Stores',
  'points-of-sale_add-point-of-sale': '+ Add',
  'points-of-sale_empty-points-of-sale': 'There are no points of sale yet',
  'points-of-sale_table_brand': 'Brand',
  'points-of-sale_table_connection': 'Connection',
  'points-of-sale_table_recive-data': 'Receive Data',
  'points-of-sale_table_share-data': 'Share Data',
  'points-of-sale_drawer_title': 'Stores',
  'points-of-sale_drawer_name_label': 'Name',
  'points-of-sale_drawer_add-edit-sale-point_point-of-sale-type': 'Type of Point of Sale',
  'points-of-sale_drawer_add-edit-sale-point_point-of-sale-type_physical': 'Physical Store',
  'points-of-sale_drawer_add-edit-sale-point_point-of-sale-type_online': 'Online Store',
  'points-of-sale_drawer_add-edit-sale-point_category': 'Category',
  'points-of-sale_drawer_add-edit-sale-point_category_input-validation': 'Please enter the point of sale category',
  'points-of-sale_drawer_exchange_label': 'Currency Type',
  'points-of-sale_drawer_add-edit-sale-point_exchange_input-validation': 'Please, enter the currency type',
  'points-of-sale_drawer_associate-brand_button_title': 'Add to brands that the point of sale works with and associate it with my brands',
  'points-of-sale_drawer_add-brand_button_title': 'Add to brands that the point of sale works with',
  'points-of-sale_drawer_selected-brand_button_title': 'Associate with my brands',
  'points-of-sale_drawer_associate-all-brands_modal-title-1': 'Requesting association to',
  'points-of-sale_drawer_associate-all-brands_modal-title-2': 'of',
  'points-of-sale_drawer_associate-all-brands_modal-title-3': 'brands',
  'points-of-sale_drawer_associate-all-brands_modal-title-4': 'brand',
  'points-of-sale_drawer_associate-all-brands_modal-button-1': 'associated brands',
  'points-of-sale_drawer_associate-all-brands_modal-button-2': 'Applying changes',
  'points-of-sale_drawer_associate_button_associate-all': 'unassociated',
  'points-of-sale_drawer_associate_button_associate-all-1': 'Associate',
  'points-of-sale_drawer_associate_button_associate-all-2': 'Brands',
  'points-of-sale_drawer_expand-less': 'See less',
  'points-of-sale_drawer_expand-more': 'See all',
  'points-of-sale_drawer_sub-title-1': 'Brands that the point of sale works with',
  'points-of-sale_drawer_sub-title-2': 'Add brands to the point of sale of',
  'points-of-sale_drawer_associate-all_popconfirm_title-1': 'Do you want to send association request to',
  'points-of-sale_drawer_associate-all_popconfirm_title-2': 'this brand',
  'points-of-sale_drawer_associate-all_popconfirm_title-3': 'these brands',
  'points-of-sale_drawer_associate-all_popconfirm_description-1': 'more',
  'points-of-sale_drawer_associate-all_popconfirm_on-ok': 'Associate',
  'points-of-sale_drawer_associate-all_popconfirm_on-cancel': 'Cancel',
  'points-of-sale_drawer_associate-all_modal_title': 'Changes made in',
  'points-of-sale_drawer_associate-all_modal_on-ok': 'Save changes',
  'points-of-sale_drawer_associate-all_modal_on-cancel': 'Discard changes',
  'points-of-sale_drawer_associate-all_modal_description-1': 'There are changes made in the point of sale of',
  'points-of-sale_drawer_associate-all_modal_description-2': 'Do you want to save the changes?',
  'points-of-sale_drawer_name_input': 'Enter a name',
  'points-of-sale_drawer_name_input-validation': 'Please, enter a name',
  'points-of-sale_drawer_own-point-of-sale_input': 'Own store',
  'points-of-sale_drawer_web_label': 'Web',
  'points-of-sale_drawer_web_input': 'Enter a website',
  'points-of-sale_drawer_address_label': 'Address',
  'points-of-sale_drawer_address_input': 'Enter an address',
  'points-of-sale_drawer_address_input-validation': 'Please, enter an address',
  'points-of-sale_drawer_postal-code_label': 'Postal Code',
  'points-of-sale_drawer_postal-code_input': 'Enter a postal code',
  'points-of-sale_drawer_postal-code_input-validation': 'Please, enter a postal code',
  'points-of-sale_drawer_city_label': 'City',
  'points-of-sale_drawer_city_input': 'Enter a city',
  'points-of-sale_drawer_city_input-validation': 'Please, enter a city',
  'points-of-sale_drawer_country_label': 'Country',
  'points-of-sale_drawer_province_label': 'State/Province',
  'points-of-sale_drawer_province_input': 'Enter a state/province',
  'points-of-sale_drawer_province_input-validation': 'Please, enter a state/province',
  'points-of-sale_drawer_region_label': 'Region',
  'points-of-sale_drawer_region_input': 'Enter a region',
  'points-of-sale_drawer_region_input-validation': 'Please, enter a region',
  'points-of-sale_drawer_tel-sufix_label': 'Phone Number',
  'points-of-sale_drawer_tel_input': 'Enter a phone number',
  'points-of-sale_drawer_tel_input-validation': 'Please, enter a phone number',
  'points-of-sale_drawer_verify-sales-checkbox': 'Enable received sales verification',
  'points-of-sale_drawer_brands_title': 'Search and add your brands at this store',
  'points-of-sale_drawer_brands_input-placeholder': 'Search',
  'points-of-sale_drawer_brands_more-brands': "Want a brand you don't see here?",
  'points-of-sale_drawer_add-point-of-sale_title': 'Add point of sale',
  'points-of-sale_drawer_add-brand_title': 'Add new brand',
  'points-of-sale_drawer_edit-point-of-sale_title': 'Edit Point of Sale',
  'points-of-sale_drawer_brands-to-associate-selected': 'Brands from',
  'points-of-sale_drawer_brands-to-associate-selected-1': '+ Association request',
  'points-of-sale_drawer_brands-selected': 'Brands at',
  'points-of-sale_drawer__brands--brand__add-brand': 'Add',
  'points-of-sale_drawer__brands--brand__asociate-brand': 'Associate',
  'points-of-sale_drawer__edit-button': 'Edit',
  'points-of-sale_add-edit-sale-point_area': 'Commercial area (M2)',
  'points-of-sale_add-edit-sale-point_center-code': 'Center code',
  'points-of-sale_add-edit-sale-point_main-contact': 'Main Contact',
  'points-of-sale_drawer_remove-point-of-sale_confirm': 'Delete point of sale',
  'points-of-sale_drawer_remove-point-of-sale_description': 'Are you sure you want to delete this point of sale?',
  'points-of-sale_drawer_remove-point-of-sale_button': 'Delete point of sale',
  /////////////////////////////

  /// THANKS PAGE //////////////
  'ThanksForRegister__register': 'BRAND REGISTRATION',
  'ThanksForRegister__title': 'Thank you for your interest in Hub4Retail!',
  'ThanksForRegister__subtitle': 'Your request is being processed and we will get back to you shortly.',
  'ThanksForRegister__button': 'Go to the website',
  /////////////////////////////

  /// REGISTER BRAND ///////////
  'RegisterBrand__title1': 'Ready to start',
  'RegisterBrand__title2': 'take your business to the',
  'RegisterBrand__title3': 'next level?',
  'RegisterBrand__subtitle': 'Platform designed for:',
  'RegisterBrand__ex1': 'Improve collaboration and sharing tools.',
  'RegisterBrand__ex2': 'Ensure data security at all times.',
  'RegisterBrand__ex3': 'Increase revenue margins.',
  'RegisterBrand__button': 'Back',
  'RegisterBrand__register': 'Registration',
  'registerBrand__form__name': 'First name',
  'registerBrand__form__lastName': 'Last name',
  'registerBrand__form__business': 'Corporate name',
  'registerBrand__form__company': 'Trade name',
  'registerBrand__form__phone': 'Website',
  'registerBrand__form__email': 'Phone',
  'registerBrand__form__web': 'Corporate email',
  'registerBrand__form__description': 'Would you like to tell us more?',
  'registerBrand__form__selector': 'Sector',
  'registerBrand__form__say-more': 'Would you like to tell us more?',
  'registerBrand__form__selector__optionDefault': '',
  'registerBrand__form__selector__option1': 'Footwear',
  'registerBrand__form__selector__option2': 'Accessories',
  'registerBrand__form__selector__option3': 'Home-Garden',
  'registerBrand__form__selector__option4': 'Beauty',
  'registerBrand__form__selector__option5': 'Electronics',
  'registerBrand__form__selector__option6': 'Sports',
  'registerBrand__form__selector__option7': 'Automotive',
  'registerBrand__form__selector__option8': 'Food',
  'registerBrand__form__selector__option9': 'Other',
  /////////////////////////////

  // BRAND PAGE //////////
  'brand-page_send-association-btn': 'Send association request',
  'brand-page_history-timeline_title': 'History',
  'brand-page_history-points-of-sale_title': 'Stores and Connection',
  'brand-page_history-points-of-sale_total': 'Total',
  'brand-page_history-points-of-sale_name': 'Name',
  'brand-page_history-points-of-sale_address': 'Address',
  'brand-page_history-points-of-sale_city': 'City',
  'brand-page_history-points-of-sale_recive-data': 'Receive Data',
  'brand-page_history-points-of-sale_recive-data_active': 'Active',
  'brand-page_history-points-of-sale_recive-data_inactive': 'Inactive',
  'brand-page_history-points-of-sale_status_associate': 'Associated',
  'brand-page_history-points-of-sale_status_pending': 'Pending',
  'brand-page_history-points-of-sale_status_no-associate': 'Not associated',
  'brand-page_history-points-of-sale_status': 'Status',
  'brand-page_history-points-of-sale_status_createdAt': 'Date',
  'brand-page_history-points-of-sale_share-data': 'Share Data',
  'brand-page_history-points-of-sale_associated': 'Associated',
  'brand-page_history-points-of-sale_not-associated': 'Not associated',
  'brand-page_history-active-contacts_name': 'Name',
  'brand-page_history-active-contacts_email': 'Email',
  'brand-page_history-active-contacts_phone-number': 'Phone Number',
  'brand-page_history-active-contacts_department': 'Department',
  'brand-page_history-active-seasons_title': 'Active Seasons',
  'brand-page_history-active-contacts_title': 'Primary Contacts',
  'brand-page_history-contacts_popover-title': 'Contact Information',
  'brand-page_history-contacts_popover-content_name': 'Name:',
  'brand-page_history-contacts_popover-content_surname': 'Surname:',
  'brand-page_history-contacts_popover-content_email': 'Email:',
  'brand-page_history-contacts_popover-content_phone-number': 'Phone Number:',
  'brand-page_history-contacts_popover-content_sector': 'Sector:',
  ////////////////////////

  // BRAND FEED PAGE ////////
  'brand-feed_page_info_title': 'About Us',
  'brand-feed_page_buttons_connect': 'Connect',
  'brand-feed_page_videos_title': 'Multimedia Catalog',
  'brand-feed_page_videos_subtitle': 'Related Videos',
  ///////////////////////////

  // SETTINGS PAGE ////////
  'settings-page_nav_chronos': 'Chronos',
  'settings-page_nav_devices': 'Devices',
  'settings-page_nav_touch-screen': 'Touch Screens',
  'settings-page_nav_users': 'Users',
  'settings-page_nav_system-settings': 'System Settings',
  'settings-page_nav_meta': 'Meta',
  'settings-page_nav_billing': 'Billing',
  'settings-page_nav_support': 'Support',
  // Users page
  'settings-page_users-page_create-user-btn': 'Create User',
  /////////////////////////

  // NOTIFICATIONS /////////////////
  // Notifications Page
  'notifications-page_notifications-title': 'Notifications',
  'notifications-page_alerts-title': 'Alerts',
  'notifications_btn-name_catalog': 'View Catalog',
  'notifications_btn-name_profile': 'View Profile',
  'notifications_list_show-all': 'All',
  'notifications_list_show-unreaded': 'Unread',
  'notifications_list_per-page-select': 'per page',
  // Popover
  'notifications_popover_title': 'NOTIFICATIONS',
  'notifications_popover_empty-notifications': 'No notifications',
  'notifications_popover_btn-name_catalog': 'View Catalog',
  'notifications_popover_btn-name_profile': 'View Profile',
  'notifications_popover_item_mark-as-readed_msg': 'Marked as read',
  'notifications_popover_item_mark-as-unreaded_msg': 'Marked as unread',
  'notifications_popover_item_mark-as-readed': 'Mark as read',
  'notifications_popover_item_mark-as-unreaded': 'Mark as unread',
  'notifications_popover_all-notifications-btn': 'All notifications',
  'notifications_popover_accept': 'Accept',
  'notifications_popover_reject': 'Reject',
  'alerts_popover_title': 'ALERTS',
  'alerts_popover_empty-notifications': 'No alerts',
  'alerts_popover_all-notifications-btn': 'All alerts',
  ///////////////////////////////////

  // SALES ///////////////////////////
  'sales_csv-info_title': 'CSV Information',
  'sales_csv-info_columns': 'Columns:',
  'sales_csv-info_rows': 'Rows:',
  'sales_csv-info_separator': 'Separator:',
  'sales_csv-info_headers': 'Headers:',
  'sales_csv-info_errors': 'Errors:',
  // Add sales CSV
  'sales_add-sales-csv-input-title': 'Upload CSV',
  'sales_add-sales-csv_warning-msg-file-pnly-contain-a-header': 'The file only contains a header',
  'sales_add-sales-csv-error-column-mismatch': 'Some lines do not match the CSV headers',
  'sales_add-sales-xlsx-input-title': 'Upload XLSX',
  'sales_add-sales-xlsx_select-row_description': 'Select the row that contains the headers',
  'sales_add-sales-xlsx_select-row_input-placeholder': 'Row number',
  'sales_add-sales-csv-s2-text-1': 'Upload CSV or XLSX sales',
  'sales_add-sales-csv-s2-text-2': 'Create or select a column mapping',
  'sales_add-sales-csv_file-limit': 'The file must not exceed 50MB.',
  // Handle not matched points of sale
  'sales_csv-upload_not-matched-points-of-sale_title': 'Unmatched Points of Sale',
  'sales_csv-upload_not-matched-points-of-sale_description': "The following points of sale do not match the company's points of sale. Please select a point of sale from the list for each unmatched point of sale.",
  'sales_csv-upload_not-matched-points-of-sale_checking-matching': 'Checking points of sale...',
  // My csv mappings
  'sales_csv-mappings_title': 'Matching Map',
  'sales_csv-mappings_title-create': 'Create a map for the CSV',
  'sales_csv-mappings_save-file_success': 'Sales file successfully uploaded',
  'sales_csv-mappings_send-file-btn': 'Upload Sales',
  // Create mapping form
  'sales_csv-mapping-form_title': 'Select CSV headers to create a map.',
  'sales_csv-mapping-form_columns-without-reference': 'Unreferenced CSV Columns:',
  'sales_csv-mapping-form_periodicity': 'Periodicity',
  'sales_csv-mapping-form_periodicity_required': 'Periodicity is required',
  'sales_csv-mapping-form_periodicity_dairy': 'Daily',
  'sales_csv-mapping-form_periodicity_weekly': 'Weekly',
  'sales_csv-mapping-form_periodicity_biweekly': 'Biweekly',
  'sales_csv-mapping-form_save-map-btn': 'Save Map',
  'sales_csv-mapping-form_onfinish_field-required-msg': 'Fields marked with * are required',
  'sales_csv-mapping-form_onfinish_map-points-of-sale-required': 'All points of sale must be mapped',
  // Mapping table
  'sales_csv-mapping-table_column-1_label': 'Sales Fields',
  'sales_csv-mapping-table_column-2_label': 'CSV Columns',
  'sales_csv-mapping-table_column-2_select-label': 'Select a column',
  'sales_csv-mapping-table_column-2_select-label-multiple': 'Select one or more columns',
  'sales_csv-mapping-table_column-2_select-format_label': 'Select a format',
  'sales_csv-mapping-table_column-3_label': 'Resulting Data',
  'sales_csv-mapping-info-popover_title': 'Creation date:',
  // MyCSVMappingInfoPopover
  'sales_csv-mapping-info-popover_periodicity': 'Periodicity:',
  'sales_csv-mapping-info-popover_periodicity-days': 'days',
  'sales_csv-mapping-info-popover_date-format': 'Date Format:',
  'sales_csv-mapping-info-popover_hour-format': 'Hour format:',
  'sales_csv-mapping-info-popover_points-of-sale-mapped': 'Mapped Points of Sale:',
  'sales_csv-mapping-info-popover_references': 'References',
  'sales_csv-mapping-info-popover_tags': 'Tags',
  'sales_csv-mapping-info-popover_columns-without-references': 'Unreferenced Columns',
  'sales_csv-mapping-info-popover_popconfirm_title': 'Are you sure you want to delete this map?',
  'sales_csv-mapping-info-popover_popconfirm_btn': 'Delete Map',
  'sales_csv-mapping-info-popover_popconfirm_ok': 'Yes',
  'sales_csv-mapping-info-popover_popconfirm_cancel': 'No',
  // SalesHistoryPage
  'sales-history_page_title': 'Sales Upload History',
  'sales-history_page_upload-btn': 'Upload Sales',
  'sales-history_page_table_column-1_title': 'Upload Date',
  'sales-history_page_table_udated-at_title': 'Last update',
  'sales-history_page_table_column-2_title': 'File Name',
  'sales-history_page_table_column-3_title': 'Status',
  'sales-history_page_table_column-3_processed': 'Processed',
  'sales-history_page_table_column-3_pending': 'Pending',
  'sales-history_page_table_column-4_popover_title': 'Delete Sales Upload',
  'sales-history_page_table_column-4_popover_description': 'Are you sure you want to delete the sales upload?',
  'sales-history_page_table_column-4_delete-btn': 'Delete',
  'sales-history_page_table_column-4_dowload-processed-success': 'Processed file correctly downloaded',
  'sales-history_page_table_column-4_dowload-error': 'Error Downloading File',
  'sales-history_page_table_column-4_dowload-original-success': 'Original file downloaded successfully',
  'sales-history_page_table_column-4_dowload-processed-file': 'Download processed file',
  'sales-history_page_table_column-4_dowload-file': 'Download file',
  'sales-history_page_table_column-4_dowload-original-file': 'Download original file',
  'sales-history_page_table_original-name': 'Original file name',
  'sales-history_page_table_upload-type': 'Upload type',
  'sales-history_page_table_file-type': 'File type',
  'sales-history_page_table_pending-mapping-title': 'Pending mapping',
  'sales-history_page_table_mapping-error-title': 'An error has occurred',
  'sales-history_page_table_download-file-error-msg': 'Error downloading the file',
  'sales-history_page_table_download-file-format-not-supported': 'File format not supported',
  'sales-history_page_table_create-mapping-label': 'Create mapping',
  'sales-history_page_table_info-popover_title': 'File lines where errors are occurring',
  'sales-history_page_table_info-popover_contact-with-us': 'If the problem persists, contact the support team (help@hub4retail.com) and provide this issue ID number:',
  'sales-history_page_table_info-popover_UNKNOWN_CHAR': 'A character that does not match the specified encoding in the file has been found.',
  'sales-history_page_table_info-popover_PTO_MISSING': 'Pending point of sale mapping.',
  'sales-history_page_table_info-popover_MISSING_PTO_MAP': 'Pending point of sale mapping.',
  'sales-history_page_table_info-popover_SKIP': 'Processing failed, skipping.',
  'sales-history_page_table_info-popover_MAP_ID_NOT_FOUND': 'No map matches, create the map to process the file.',
  'sales-history_page_table_info-popover_MAPS_NOT_FOUND': 'No maps match, create the map to process the file.',
  'sales-history_page_table_info-popover_MAP_NOT_FOUND': 'No map matches, create the map to process the file.',
  'sales-history_page_table_info-popover_BRAND_CLIENT_ID_NOT_FOUND': 'There is a file created in a folder with a brand or client ID that no longer exists in the database.',
  'sales-history_page_table_info-popover_FOLDER_NOT_FOUND': 'The SFTP user record contains a brand or client ID, but the folder with this ID does not exist in Amazon S3, so it is not possible to retrieve the files.',
  'sales-history_page_table_info-popover_FOLDER_LIST_UNAVAILABLE': 'Unable to connect to Amazon S3. The AWS user has been deleted, or permissions have changed, making the connection to S3 impossible.',
  'sales-history_page_table_info-popover_FILES_NOT_FOUND': 'The folder for that brand or client is empty. No files to process.',
  'sales-history_page_table_info-popover_NO_CONTENT_TYPE': 'The file uploaded to AWS does not have a defined content type.',
  'sales-history_page_table_info-popover_NO_ENCODING': 'The file uploaded to AWS does not have a defined content type.',
  'sales-history_page_table_info-popover_NO_FILE_METADATA': 'Unable to read the file content.',
  'sales-history_page_table_info-popover_CANNOT_CREATE_BUFFER': 'Unable to convert the file data stream to a buffer.',
  'sales-history_page_table_info-popover_HEADERS_NOT_FOUND': 'File headers not found.',
  'sales-history_page_table_info-popover_SIGNATURE_MISMATCH': 'No map matches, create the map to process the file.',
  'sales-history_page_table_info-popover_SEPARATOR_NOT_FOUND': 'No separator found in the map.',
  'sales-history_page_table_info-popover_SEPARATOR_MISMATCH': 'The separator in the map does not match the separator found in the file header.',
  'sales-history_page_table_info-popover_DATAEFORMAT_NOT_FOUND': 'Date format not found.',
  'sales-history_page_table_info-popover_DATE_PARSE_ERROR': 'The date format in the map does not match the date format in the file.',
  'sales-history_page_table_info-popover_JSON_NORM_ERROR': 'Data file (json) reading aborted due to errors.',
  'sales-history_page_table_info-popover_JSON_PARSE_ABORT': 'Process aborted due to errors.',
  'sales-history_page_table_info-popover_BRAND_CLIENT_NOT_FOUND': 'Brand or client IDs not found.',
  'sales-history_page_table_info-popover_MISSING_CSV_DATA': 'The CSV has no data. Delete the file if necessary.',
  'sales-history_page_table_info-popover_DATA_TRIM_ERROR': 'Unable to normalize spaces in some strings.',
  'sales-history_page_table_info-popover_DATA_INTEGRITY_ERROR': 'The number of columns in some rows does not match the number of headers. Fix the file and re-upload.',
  'sales-history_page_table_search_reset': 'Reset',
  'sales-history_page_delete-sales-history-not-processed-popover_title': 'Delete all unprocessed sales',
  'sales-history_page_delete-sales-history-not-processed-popover_description': 'Are you sure you want to delete all unprocessed sales?',
  'sales-history_page_delete-sales-history-not-processed-popover_delete-all-btn': 'Delete all',
  'sales-history_page_delete-sales-history-not-processed-msg-success': 'All unprocessed files have been deleted',
  'sales-history_page_reload-sales-history': 'Reload history',
  'sales-history_page_map-api-points-of-sale-modal_title': 'Map pending API points of sale',
  'sales-history_page_map-api-points-of-sale-modal_button': 'Map API points of sale',
  'sales-history_page_map-api-points-of-sale-modal_msg-success': 'Points of sale mapped successfully. Changes will be reflected in approximately 24 hours.',
  'sales-history_page_map-api-points-of-sale-modal_map-msg-error': 'Error mapping points of sale',
  'sales-history_page_map-api-points-of-sale-modal_get-point-of-sale-msg-error': 'Error retrieving points of sale',
  'sales-history_page_map-api-points-of-sale-modal_ignore-button': 'Ignore',
  ////////////////////////////////////

  // SALES MATCHING ///////////////////////////////////////////////
  'sales-matching_columns_search-on': 'Search on',
  'sales-matching_columns_operator_contains': 'Contains',
  'sales-matching_columns_operator_ends-with': 'Ends with',
  'sales-matching_columns_operator_starts-with': 'Starts with',
  'sales-matching_columns_operator_equals': 'Equals',
  'sales-matching_columns_operator_not-equals': 'Not equal',
  'sales-matching_columns_operator_in': 'With',
  'sales-matching_columns_operator_not-in': 'Without',
  'sales-matching_columns_operator_greater-than': 'Greater than',
  'sales-matching_columns_operator_less-than': 'Less than',
  'sales-matching_columns_operator_is-null': 'Is empty',
  'sales-matching_columns_operator_is-not-null': 'Is not empty',
  'sales-matching_columns_column-search_search': 'Search',
  'sales-matching_columns_column-search_reset': 'Reset',
  'sales-matching_columns_column-search_close': 'Close',
  'sales-matching_confirm-match': 'Are you sure you want to save the changes?',
  /////////////////////////////////////////////////////////////////

  // MAPPING KEYS //////////////////////////////////////
  // Sales mapping keys
  'mapping-keys-field__multibrand': 'Multibrand',
  'mapping-keys-field__multibrand_point_of_sale': 'Point of Sale',
  'mapping-keys-field__point_of_sale_id': 'Point of sale ID',
  'mapping-keys-field__client_id': 'Multibrand ID',
  'mapping-keys-field__date': 'Date',
  'mapping-keys-field__hour': 'Hour',
  'mapping-keys-field__floor': 'Floor',
  'mapping-keys-field__caja': 'Cash Register',
  'mapping-keys-field__order_number': 'Order Number',
  'mapping-keys-field__order_line': 'Order Line',
  'mapping-keys-field__product_reference': 'Product Reference',
  'mapping-keys-field__product_description': 'Product Description',
  'mapping-keys-field__brand_ean': 'Brand EAN',
  'mapping-keys-field__product_ean_code': 'Multibrand EAN',
  'mapping-keys-field__product_brand': 'Brand',
  'mapping-keys-field__color_code': 'Color Code',
  'mapping-keys-field__product_color': 'Color Name',
  'mapping-keys-field__product_size_eu': 'Size',
  'mapping-keys-field__product_season': 'Season',
  'mapping-keys-field__division': 'Division',
  'mapping-keys-field__family': 'Family',
  'mapping-keys-field__subfamily': 'Sub Family',
  'mapping-keys-field__gender': 'Gender',
  'mapping-keys-field__units': 'Units',
  'mapping-keys-field__price': 'Sales Price',
  'mapping-keys-field__cost': 'Purchase Price',
  'mapping-keys-field__discount': 'Discount Amount',
  'mapping-keys-field__discount_percentaje': 'Discount%',
  'mapping-keys-field__payment_method': 'Payment Method',
  'mapping-keys-field__seller': 'Seller',
  // Products mapping keys
  'mapping-keys-field__name': 'Product name',
  'mapping-keys-field__reference': 'Reference',
  'mapping-keys-field__color': 'Color',
  'mapping-keys-field__season': 'Season',
  'mapping-keys-field__ean': 'EAN',
  'mapping-keys-field__material': 'Material',
  'mapping-keys-field__segmentation': 'Segmentation',
  'mapping-keys-field__tier': 'Catalog segmentation (Tier)',
  'mapping-keys-field__color_description': 'Color description',
  'mapping-keys-field__pvi': 'PVI',
  'mapping-keys-field__pvpr': 'PVPR',
  'mapping-keys-field__size': 'Size',
  'mapping-keys-field__tags': 'Tags',
  //////////////////////////////////////////////////////

  // META ///////////////////////////
  'meta_connections_title': 'Connections',
  'meta_connections_new-connection': '+ New',
  'meta_connections_modal_title': 'New connection',
  'meta_connections_modal_title_edit': 'Edit connection',
  'meta_connections_modal_form_user-name': 'Username',
  'meta_connections_modal_form_user-name_required': 'Please enter the username',
  'meta_connections_modal_form_password': 'Password',
  'meta_connections_modal_form_password_required': 'Please enter the password',
  'meta_connections_modal_form_period': 'Frequency',
  'meta_table_createdAt': 'Creation date',
  'meta_table_user-name': 'User',
  'meta_table_password': 'Password',
  'meta_table_type': 'Type',
  'meta_table_period': 'Send frequency',
  'meta_connections_configuration-btn': 'Configuration',
  'meta_connections_configuration-btn_maps': 'Maps',
  'meta_connections_configuration-btn_fields': 'Instructions',
  'meta_connections_configuration-btn_shopify': 'Shopify',
  'meta_connections_shopify-configuration_copy': 'Copy',
  'meta_connections_shopify-configuration_query-templates': 'Hub4Retail query templates',
  'meta_connections_shopify-configuration_query-templates_table_title': 'My query templates',
  'meta_connections_shopify-configuration_query-templates_table_tag': 'Tag',
  'meta_connections_shopify-configuration_query-templates_table_queries': 'Queries',
  'meta_connections_shopify-configuration_query-templates_table_popconfirn-delete_title': 'Are you sure you want to delete this template?',
  'meta_connections_shopify-configuration_query-templates_table_popconfirn-delete_description': 'This action cannot be undone',
  'meta_connections_shopify-configuration_query-templates-form_title-create': 'New Query',
  'meta_connections_shopify-configuration_query-templates-form_title-update': 'Edit Query:',
  'meta_connections_shopify-configuration_query-templates-form_template-name': 'Template name',
  'meta_connections_shopify-configuration_query-templates-form_template-name_required': 'Template name is required',
  'meta_connections_shopify-configuration_query-templates-form_queries': 'Queries',
  'meta_connections_shopify-configuration_query-templates-form_queries_required': 'Queries are required',
  'meta_connections_shopify-configuration_query-templates-form_queries_placeholder': 'Select the queries',
  'meta_connections_shopify-configuration_my-queries_title': 'My queries',
  'meta_connections_shopify-configuration_my-queries_table_created-at': 'Creation date',
  'meta_connections_shopify-configuration_my-queries_table_tag': 'Tag',
  'meta_connections_shopify-configuration_my-queries_table_description': 'Description',
  'meta_connections_shopify-configuration_my-queries_table_graphql-query': 'GraphQL query',
  'meta_connections_shopify-configuration_my-queries_table_delete-popconfirm_title': 'Are you sure you want to delete this Query?',
  'meta_connections_shopify-configuration_my-queries_table_delete-popconfirm_description': 'This action cannot be undone',
  'meta_connections_shopify-configuration_query-form_title': 'Edit query:',
  'meta_connections_shopify-configuration_query-form_query-name': 'Query name',
  'meta_connections_shopify-configuration_query-form_query-name_required': 'Query name is required',
  'meta_connections_shopify-configuration_query-form_description': 'Description',
  'meta_connections_shopify-configuration_query-form_description_required': 'Description is required',
  'meta_connections_shopify-configuration_query-form_graphql-query': 'GraphQL query',
  'meta_connections_shopify-configuration_query-form_graphql-query_required': 'Query is required',
  'meta_connections_shopify-configuration_test-query_data-msg-1': 'You need to add the query',
  'meta_connections_shopify-configuration_test-query_data-msg-2': 'from Shop to the connector of',
  'meta_connections_shopify-configuration_test-query_data-msg-3': 'No connection with the connector',
  'meta_connections_shopify-configuration_test-query_data-msg-4': 'No connection with Shopify',
  'meta_connections_shopify-configuration_test-query_title': 'Test query',
  'meta_connections_shopify-configuration_test-query_btn-success': 'Save and test',
  'meta_connections_shopify-configuration_edit-api-connection_title': 'Connector settings for',
  'meta_connections_shopify-configuration_edit-api-connection_get-sample': 'Get sample',
  'meta_connections_shopify-configuration_edit-api-connection_empty-sample': 'No queries available for this connector.',
  'meta_connections_shopify-configuration_edit-api-connection_go-to-api-configuration': 'Go to API configuration of',
  'meta_connections_shopify-configuration_edit-api-connection_go-to-configuration': 'Go to configuration',
  'meta_connections_shopify-configuration_edit-api-connection_select-queries': 'Select the queries you want to run on the connector of',
  'meta_connections_shopify-configuration_field-table-list_title': 'Map instructions',
  'meta_connections_shopify-configuration_field-table-list_delete-fields': 'Delete instructions',
  'meta_connections_shopify-configuration_field-table-list_import-fields': 'Import instructions',
  'meta_connections_shopify-configuration_field-table-list_add-field': 'Add instruction',
  'meta_connections_shopify-configuration_field-table-list_handle-field-form_select-form': 'Select the form type',
  'meta_connections_shopify-configuration_field-table-list_handle-field-form_select-field-type': 'Select the instruction type:',
  'meta_connections_shopify-configuration_field-table-list_handle-field-form_delete-map-field-modal_title': 'Remove instruction from map',
  'meta_connections_shopify-configuration_field-table-list_handle-field-form_delete-map-field-modal_onOk': 'Remove from map',
  'meta_connections_shopify-configuration_field-table-list_handle-field-form_delete-map-field-modal_description-1': 'Are you sure you want to remove the instruction',
  'meta_connections_shopify-configuration_field-table-list_handle-field-form_delete-map-field-modal_description-2': 'from the map?',
  'meta_connections_shopify-configuration_field-table-list_handle-field-form_import-map-fields_modal_title': 'Import instructions',
  'meta_connections_shopify-configuration_field-table-list_handle-field-form_import-map-fields_modal_btn_import': 'Import',
  'meta_connections_shopify-configuration_field-table-list_handle-field-form_import-map-fields_modal_my-queries-templates': 'My instruction templates',
  'meta_connections_shopify-configuration_field-table-list_handle-field-form_import-map-fields_modal_emprty-templates': 'No instruction templates',
  'meta_connections_shopify-configuration_field-table-list_handle-field-form_import-map-fields_modal_go-to-fields': 'Go to instructions',
  'meta_connections_shopify-configuration_test-map_title': 'Test map',
  'meta_connections_shopify-configuration_test-map_form_audience': 'Audience',
  'meta_connections_shopify-configuration_test-map_form_audience-placeholder': 'Select an audience',
  'meta_connections_shopify-configuration_test-map_form_query': 'Select a query to test mapping',
  'meta_connections_shopify-configuration_test-map_form_query-response': 'Or copy the code you want to map',
  'meta_connections_shopify-configuration_test-map_form_clean': 'Clean',
  'meta_connections_shopify-configuration_test-map_form_test': 'Test',
  'meta_connections_shopify-configuration_test-map_empty-results': 'No results',
  'meta_connections_shopify-configuration_test-map_info': 'Info:',
  'meta_connections_shopify-configuration_test-map_errors': 'Errors:',
  'meta_connections_shopify-configuration_test-map_result': 'Resulting data:',
  'meta_connections_shopify-configuration_maps_title': 'My maps',
  'meta_connections_shopify-configuration_maps_create-map-btn': 'Create map',
  'meta_connections_shopify-configuration_maps_name': 'Name',
  'meta_connections_shopify-configuration_maps_description': 'Description',
  'meta_connections_shopify-configuration_maps_audience': 'Audience type',
  'meta_connections_shopify-configuration_maps_fields': 'No. of instructions',
  'meta_connections_shopify-configuration_maps_created-at': 'Creation date',
  'meta_connections_shopify-configuration_maps_delete_title': 'Are you sure you want to delete this map?',
  'meta_connections_shopify-configuration_maps_create-map_modal_title': 'Create map',
  'meta_connections_shopify-configuration_maps_create-map_modal_form_tag': 'Map name',
  'meta_connections_shopify-configuration_maps_create-map_modal_form_description': 'Map description',
  'meta_connections_shopify-configuration_maps_create-map_modal_form_item-required': 'This field is required',
  'meta_connections_shopify-configuration_maps_create-map_modal_form_audience': 'Audience',
  'meta_connections_shopify-configuration_maps_create-map_modal_form_audience-placeholder': 'Select an audience',
  'meta_connections_shopify-configuration_maps_create-map_modal_form_submit-btn': 'Create map',
  'meta_connections_map-fields-configuration_title': 'Instruction settings',
  'meta_connections_map-fields-configuration_copy-fields-template': 'Copy',
  'meta_connections_map-fields-configuration_h4r-fields-templates_title': 'Hub4Retail instruction templates',
  'meta_connections_map-fields-configuration_my-fields-templates_title': 'My instruction templates',
  'meta_connections_map-fields-configuration_my-fields-templates_empty-templates': 'No instruction templates',
  'meta_connections_map-fields-configuration_my-fields-templates_popconfirn-delete-title': 'Are you sure you want to delete this instruction template?',
  'meta_connections_map-fields-configuration_my-fields_title': 'My instructions',
  'meta_connections_map-fields-configuration_my-fields_delete-selection': 'Delete selection',
  'meta_connections_map-fields-configuration_my-fields_delete-popconfirm-title': 'Are you sure you want to delete this instruction?',
  'meta_table_connection-name': 'Connection name',
  'meta_table_last-update': 'Last upload',
  'meta_table_last-connection': 'Last connection',
  'meta_table_status': 'Status',
  'meta_connections_modal_popover-title': 'Connection info',
  'meta_connections_edit-info_title': 'Edit connection info',
  'meta_connections_edit-map_title': 'Edit map info',
  'meta_connections_edit-map_form_tag': 'Map name',
  'meta_connections_edit-map_form_description': 'Map description',
  'meta_connections_edit-map_form_required': 'This field is required',
  'meta_connections_edit-map_form_audience': 'Audience',
  'meta_connections_edit-map_form_audience-placeholder': 'Select an audience',
  'meta_connections_edit-map_form_submit': 'Update',
  'meta_connections_edit-configuration_title': 'Edit the connection configuration of',
  'meta_connections_edit-info_btn-tooltip': 'Edit connection',
  'meta_connections_remove-popover_title': 'Remove connection with Shopify',
  'meta_connections_remove-popover_description': 'Are you sure you want to remove the connection with Shopify?',
  'meta_connections_edit-connection-mapping_title': 'Select the map type for the connection with Shopify',
  'meta_connections_edit-connection-mapping_select': 'Select the audience of the map:',
  'meta_connections_edit-connection-mapping_select_catalog': 'Catalog',
  'meta_connections_edit-connection-mapping_select_sale': 'Sales',
  // Shopify form
  'meta_connections_modal_form_shopify_domain': 'Domain',
  'meta_connections_modal_form_shopify_domain-required': 'Shopify domain is required',
  'meta_connections_modal_form_shopify_access-token': 'Access token',
  'meta_connections_modal_form_shopify_access-token-required': 'Shopify access token is required',
  'meta_connections_modal_form_shopify_access-api-secret-key': 'API secret key',
  'meta_connections_modal_form_shopify_access-api-secret-key-required': 'Shopify API secret key is required',
  'meta_connections_modal_form_shopify_steps_create-connection_title': 'Create the connection',
  'meta_connections_modal_form_shopify_steps_set-connection_title': 'Set the connection',
  'meta_connections_modal_form_shopify_go-to-connections': 'Back to connections',
  'meta_connections_modal_form_shopify_alert-success': 'Shopify API connection established.',
  'meta_connections_modal_form_shopify_alert-error': 'No connection with Shopify API, please check the details and save the connection again.',
  // Prestashop form
  'meta_connections_modal_form_prestashop_store-url': 'Store URL',
  'meta_connections_modal_form_prestashop_store-url-required': 'Shopify store URL is required',
  'meta_connections_modal_form_prestashop_version': 'Prestashop version',
  'meta_connections_modal_form_prestashop_version-required': 'Prestashop version is required',
  // Odoo form
  'meta_connections_modal_form_odoo_instance-url': 'Instance URL',
  'meta_connections_modal_form_odoo_instance-url-required': 'Odoo instance URL is required',
  'meta_connections_modal_form_odoo_user-name': 'Username',
  'meta_connections_modal_form_odoo_user-name-required': 'Odoo username is required',
  'meta_connections_modal_form_odoo_database-name': 'Database name',
  'meta_connections_modal_form_odoo_database-name-required': 'Odoo database name is required',
  // Shared
  'meta_connections_api-connections_comming-soon': 'Coming soon...',
  'meta_connections_create-new-connection_connection-type': 'Connection type:',
  'meta_connections_form-items_tag-form-item_label': 'Connection name',
  'meta_connections_form-items_tag-form-item_label-required': 'Please enter a name',
  'meta_connections_form-items_period-form-item_label-required': 'Please enter a period',
  'meta_connections_modal_form_access-api-key': 'API key',
  'meta_connections_modal_form_access-api-key-required': 'Shopify API key is required',
  'meta_table_status_success': 'Active',
  'meta_table_status_error': 'Error',
  'meta_connections_shopify.configuration-form_items_template-label': 'Templates',
  'meta_connections_shopify.configuration-form_items_template-label-placeholder': 'Select one or more templates',
  'meta_connections_shopify.configuration-form_items_queries-label': 'Queries',
  'meta_connections_shopify.configuration-form_items_queries-check-all': 'Check all',
  ////////////////////////////////

  // ACTIONS/REDUCER ///////////////
  // User
  'action_user_login-user-action_verify-error': 'Error verifying user.',
  'action_user_update-user-action_success': 'User successfully updated.',
  'action_user_update-user-action_error-1': 'You do not have permissions.',
  'action_user_update-user-action_error-2': 'Error updating user.',
  'action_user_update-company-action_success': 'Company data successfully updated.',
  'action_user_update-company-action_error-1': 'User not found.',
  'action_user_update-company-action_error-2': 'Error updating company data.',
  'action_user_update-company-action_error-3': 'Error adding social media.',
  'action_user_update-user-avatar-action_success': 'User avatar successfully updated.',
  'action_user_update-user-avatar-action_error-1': 'Error updating user avatar.',
  'action_user_update-company-logo-action_success': 'Company logo successfully updated.',
  'action_user_update-company-logo-action_error-1': 'Error updating company logo.',
  'action_user_update-social-media-action_success': 'Social media successfully updated.',
  'action_user_update-social-media-action_error': 'Error updating social media.',
  'action_user_remove-social-media-action_success': 'Social media successfully removed.',
  'action_user_remove-social-media-action_error': 'Error removing social media.',
  // Main contacts
  'action_get-main-contacts_error': 'Error getting main contacts',
  'action_select-main-contact_error': 'Error selecting main contacts',
  'action_create-main-contact_success': 'Contact created successfully',
  'action_create-main-contact_error': 'Error creating contact',
  'action_update-main-contact_success': 'Contact updated successfully',
  'action_update-main-contact_error': 'Error updating contact',
  'action_delete-main-contact_success': 'Contact deleted successfully',
  'action_delete-main-contact_error': 'Error deleting contact',
  // My Brands
  'action_my-brands_get-my-brands_error': 'Error getting my brands',
  'action_my-brands_remove-from-my-brands_success': 'Brand unlinked successfully',
  'action_my-brands_remove-from-my-brands-multiple_success': 'Brands successfully unlinked',
  'action_my-brands_remove-from-my-brands_error': 'Error unlinking the brand',
  'action_my-brands_add-to-my-brands_exists': 'You have already added this brand',
  'action_my-brands_add-to-my-brands_error': 'Error adding the brand',
  'action_my-brands_add-to-my-brands_success': 'Association request sent successfully',
  'action_my-brands_create-new-brand_success': 'Brand added successfully',
  'action_my-brands_create-new-brand_exists': 'A brand with the same name already exists',
  'action_my-brands_add-to-my-brands_brand-without-tenant': 'The brand is not yet on the platform, we will contact you when it is available',
  'action_my-brands_resend-association-email_success': 'Association email successfully resent',
  'action_my-brands_resend-association-email_error': 'Error resending the association email',
  // Brand
  'action_brand_get-brand_error': 'Error obtaining the brand',
  'action_brand_get-brand_contact-errors': 'Error obtaining brand contacts',
  'action_brand_share-data-with-brand_error': 'Error sharing data with the brand',
  'action_brand_share-data-with-brand_share-success': 'Sharing data with the point of sale',
  'action_brand_share-data-with-brand_no-share-success': 'You have stopped sharing data with the point of sale',
  // Sales CSV upload
  'sales-csv-upload_reject-upload-success': 'Sales upload successfully removed',
  'sales-csv-upload_reject-upload-error': 'Error removing sales upload',
  'sales-csv-upload_get-mappings-error-1': 'Error fetching mapping keys',
  'sales-csv-upload_get-mappings-error-2': 'Server error fetching mapping keys',
  'sales-csv-upload_get-mappings-error-3': 'Error fetching my mappings',
  'sales-csv-upload_delete-mapping-success': 'Mapping successfully removed',
  'sales-csv-upload_delete-mapping-error': 'Error removing mapping',
  'sales-csv-upload_create-mapping-success': 'Mapping successfully created',
  'sales-csv-upload_create-mapping-success_without-send-file': 'Map created successfully. It usually takes less than two minutes to appear in the list.',
  'sales-csv-upload_create-mapping-error': 'Error creating mapping',
  // Meta
  'action_meta_get-connections_error': 'Error fetching the connections',
  'action_meta_delete-connection_success': 'Connection successfully deleted',
  'action_meta_delete-connection_error': 'Error deleting the connection',
  'action_meta_create-connection_success': 'Connection successfully created',
  'action_meta_get-queries_error': 'Error retrieving queries',
  'action_meta_create-sftp-connection_error-403': 'Username already exists. Try another one.',
  'action_meta_get-mapping-keys_error': 'Error retrieving mapping keys',
  'action_meta_create-shopify-connection_error-409': 'Domain is already in use',
  'action_meta_create-shopify-connection_error': 'Error creating connection',
  'action_meta_update-connection_success': 'Connection successfully updated',
  'action_meta_update-connection_error': 'Error updating connection',
  'action_meta_create-connection_error': 'Error creating the connection',
  // Main contacts
  'actions_main-contacts_get-main-contacts_error': 'Error fetching main contacts',
  'actions_main-contacts_create-main-contact_success': 'Contact successfully created',
  'actions_main-contacts_create-main-contact_error': 'Error creating contact',
  'actions_main-contacts_update-main-contact_success': 'Contact successfully updated',
  'actions_main-contacts_update-main-contact_error': 'Error updating contact',
  'actions_main-contacts_delete-main-contact_success': 'Contact successfully deleted',
  'actions_main-contacts_delete-main-contact_error': 'Error deleting contact',
  // Points of sale
  'action_points-of-sale_get-points-of-sale_error': 'Error retrieving points of sale',
  'action_points-of-sale_create-point-of-sale_success': 'Point of sale created successfully',
  'action_points-of-sale_create-point-of-sale_error': 'Error creating point of sale',
  'action_points-of-sale_assign-point-of-sale-categories_error': 'Error assigning categories to the point of sale',
  'action_points-of-sale_update-point-of-sale_success': 'Point of sale updated successfully',
  'action_points-of-sale_update-point-of-sale_error': 'Error updating point of sale',
  'action_points-of-sale_delete-point-of-sale_success': 'Point of sale deleted successfully',
  'action_points-of-sale_delete-point-of-sale_error': 'Error deleting point of sale',
  'action_points-of-sale_delete-point-of-sale_not-authorized-error': 'This point of sale is linked to products and cannot be deleted',
  // Brand users
  'actions_brand-users_get-brand-users_error': 'Error fetching users',
  'actions_brand-users_create-brand-user_success': 'User created successfully',
  'actions_brand-users_create-brand-user_exists': 'User already exists',
  'actions_brand-users_create-brand-user_error': 'Error creating user',
  'actions_brand-users_update-brand-user_success': 'User updated successfully',
  'actions_brand-users_update-brand-user_error': 'Error updating user',
  'actions_brand-users_update-brand-user_rol-error': 'Error updating user role',
  'actions_brand-users_update-brand-user_notifications-error': 'Error updating notification types',
  'actions_brand-users_delete-brand-user_success': 'User deleted successfully',
  'actions_brand-users_delete-brand-user_error': 'Error deleting user',
  // Sales matching
  'sales-matching_match-sale_success': 'Sale successfully matched',
  'sales-matching_match-sale_error': 'Could not match the sale',
  'sales-matching_match-sale_premission-error': 'You do not have permission to match sales',
  //////////////////////////

  // MESSAGE PAGES //////////
  // Error
  'errors-page_404_subtitle': 'Sorry, the page you are looking for does not exist.',
  'errors-page_404_btn-go-back': 'Go back',
  // Coming soon
  'coming-soon-page_title': 'Coming Soon!',
  'coming-soon-page_go-back': 'Go Back',
  /////////////////////////

  // BREADCRUMBS ///////////////
  //Multimedia
  'breadcrumbs_multimedia': 'Multimedia',
  'breadcrumbs_multimedia-videos': 'Videos',
  'breadcrumbs_multimedia-images': 'Images',
  // Sales
  'breadcrumbs_sales': 'Sales',
  'breadcrumbs_sales-create': 'Upload Sales',
  // Catalog
  'breadcrumb_catalog': 'Catalog',
  'breadcrumb_product': 'All Brands',
  'breadcrumb_catalog-download': 'Download catalog',
  // Clients
  'breadcrumbs_clients': 'Clients',
  'breadcrumbs_clients-list': 'Clients list',
  'breadcrumbs_add-client': 'Add client',
  'breadcrumbs_resume': 'Summary',
  'breadcrumbs_business-info': 'Business information',
  'breadcrumbs_main-contacts': 'Main contacts',
  'breadcrumbs_sale-points': 'Stores',
  'breadcrumbs_commercial-info': 'Commercial information',
  // Account
  'breadcrumbs_account': 'Account',
  'breadcrumbs_account_profile': 'Profile',
  'breadcrumbs_account_company': 'Company Information',
  'breadcrumbs_account_contacts': 'Key Contacts',
  'breadcrumbs_account_my-brands': 'My Brands',
  'breadcrumbs_account_points-of-sale': 'Points of Sale',
  // Meta
  'breadcrumbs_meta_edit_connetion': 'Edit connection',
  'breadcrumbs_meta_map_list': 'Maps',
  'breadcrumbs_meta_edit_map': 'Edit map',
  'breadcrumbs_meta_fields-configuration': 'Instruction settings',
  //////////////////////////////

  // REFERRAL PROGRAM //////////////////////////
  'referral-program_title': 'Invite to',
  //////////////////////////////

  // MODALS ////////////////////
  'modal_email-verified_title': 'Check your email',
  'modal_email-verified_content': 'To proceed with the process, please check your email',
  'modal_email-verified_content-1': 'Verify the address from the received email link and then click',
  'modal_email-verified_content_btn_resend': 'Resend Verification',
  'modal_email-verified_content_btn_reload': 'Reload',
  'modal_email-verified_content_notif_resend_title_success': 'Verification email resent successfully.',
  'modal_email-verified_content_notif_resend_title_error': 'An error occurred while resending the verification email.',
  'modal_email-verified_content_notif_resend_title': 'Resend Notification',
  'modal_email-verified_content_notif_resend_content-1': 'The verification email has been sent to this address',
  'modal_email-verified_content_notif_resend_content-2': 'Check your email to continue.',
  //////////////////////////////

  // POLICY PRIVACY //////////
  'policy-privacy-modal_title': 'Terms of Service',
  'policy-privacy-modal_btn-accept': 'Accept',
  'policy-privacy-modal_btn-cancel': 'Cancel',
  'policy-privacy-modal_checkbox': 'I accept the Terms of Service',
  'policy-privacy-modal_checkbox-message': 'Accept the privacy policy and terms.',
  ////////////////////////////

  // SERVER DOWN MODAL /////
  'server-down-modal_title': 'Server Error',
  'server-down-modal_content': 'We are experiencing issues with our services. Please try again later or contact technical support.',
  //////////////////////////

  // CHANGE DEFAULT PASSWORD MODAL /////////////////
  'change-default-password-modal_title': 'Change the password to continue',
  'change-default-password_error-1': 'Error changing the password',
  'change-default-password_error-2': 'Error updating the user',
  'change-default-password_error-3': 'Server error',
  //////////////////////////////////////////////////

  // NOTIFICATIONS /////////
  'notification-error_message': 'Error Code',
  'notification-error_description': 'Please try again later. If the problem persists, contact Hub4Retail (help@hub4retail.com) and provide the error code.',
  //////////////////////////

  // NOTIFICATIONS TYPES /////////
  'notifications_type_catalog_wh-upload-sales-reminder': 'Multibrand sales upload reminder',
  'notifications_type_catalog_wh-first-upload-sales-reminder': 'First sales upload',
  'notifications_type_catalog_br-accepts-request': 'Brand accepted association request',
  'notifications_type_catalog_file-error': 'File error',
  'notifications_type_catalog_file-success': 'File processed',
  'notifications_type_catalog_wh-point-of-sale-associated': 'Point of sale associated',
  'notifications_type_catalog_wh-request-association': 'Client requests association',
  'notifications_type_catalog_wh-pos-map-reminder': 'Point of sale mapping reminder',
  ////////////////////////////////

  // GOOGLE ADDRESS FORM //////
  'google-address-form_address': 'Address',
  'google-address-form_floor': 'Floor',
  'google-address-form_door': 'Door',
  'google-address-form_postal-code': 'Postal Code',
  'google-address-form_city': 'City',
  'google-address-form_province': 'Province',
  'google-address-form_country': 'Country',
  'google-address-form_select-country': 'Select a country',
  //////////////////////////////

  // UI ///////////////////////
  'copy-to-clipboard-success': 'Copied to clipboard',
  /////////////////////////////

  // SHARED //////////////////
  'settings': 'Settings',
  'logout': 'Logout',
  'admin-panel_link': 'Admin Panel',
  'btn-save': 'Save',
  'btn-cancel': 'Cancel',
  'see-more-content-button': 'See more',
  'see-less-content-button': 'See less',
  'see-all-content-button': 'See all',
  'search-btn-label': 'Search',
  'close-btn-label': 'Close',
  'remove-label': 'Delete',
  'reset-btn': 'Reset',
  'btn-next': 'Next',
  'send-btn': 'Send',
  'not-authorized-warning': 'You do not have permission to perform this action',
  'form-label_role': 'Role',
  'form-label_language': 'Language',
  ////////////////////////////
};

export default englishTranslation;
